import React, { Component } from 'react';

import { Button } from '@lt/components';
import { scrollToFlights } from 'checkout/utils/globalUtils';

const baseCls = 'go-to-flights';

class GoToFlightButtonMobile extends Component {
  constructor(props) {
    super(props);

    this.state = { show: true };

    this.handleIntersect = this.handleIntersect.bind(this);
    this.observer = new IntersectionObserver(this.handleIntersect);
  }

  componentDidMount() {
    const routeContainer = document.querySelector('.checkout_page_new__main');
    this.observer.observe(routeContainer);
  }

  handleIntersect(entries) {
    const [entry] = entries;
    const { intersectionRatio } = entry;
    this.setState({ show: intersectionRatio === 0 });
  }

  render() {
    const { show } = this.state;
    return (
      show && (
        <div className={`${baseCls}-fixed-container`}>
          <div className={`${baseCls}-container`}>
            <Button
              className={`${baseCls}-button`}
              primary
              onClick={scrollToFlights}
            >
              Выбрать перелёт
            </Button>
          </div>
        </div>
      )
    );
  }
}

export default GoToFlightButtonMobile;
